import React from 'react';
import { Icon, Image, Segment } from 'semantic-ui-react';

const isPdf = currentFile => currentFile.src.startsWith('data:application/pdf')
  || (currentFile.filename && currentFile.filename.endsWith('.pdf'));
const isXml = currentFile => currentFile.src.startsWith('data:application/xml')
  || (currentFile.filename && currentFile.filename.endsWith('.xml'));

const FilePreview = ({ currentFile }) => {
  if (currentFile.src) {
    if (isXml(currentFile)) {
      return (
        <Segment basic>
          <Icon name='file outline' size='huge' />
          <span>{currentFile.filename}</span>
        </Segment>
      );
    }

    if (isPdf(currentFile)) {
      return <iframe title='file-preview' src={currentFile.src} style={{ width: '100%', height: '100%' }} />;
    }
    return (
      <Segment basic className='flexbox-centered' style={{ margin: 0, padding: 0 }}>
        <Image
          src={currentFile.src}
          alt='preview'
          style={{ objectFit: 'contain', maxHeight: '70vh' }}
        />
      </Segment>
    );
  }
  return <></>;
};

export default FilePreview;
